export default __webpack_public_path__ + "static/media/settings.c30b72b3.svg";